var SpriteSymbol = require("../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 56 56",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56 56\" id=\"close\"><g fill-rule=\"evenodd\"><path d=\"m15.98 14.565 25.455 25.456-1.414 1.414-25.456-25.456z\" /><path d=\"M40.02 14.565 14.566 40.021l1.414 1.414 25.456-25.456z\" /></g></symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol